import { render } from "./VLink.vue?vue&type=template&id=03e0f4ce"
import script from "./VLink.vue?vue&type=script&lang=js"
export * from "./VLink.vue?vue&type=script&lang=js"
script.render = render

export default script